<div class="markdown-fallback" *ngIf="changelogContent">
  <pre>{{ changelogContent }}</pre>
</div>
